import React from 'react';
import './LoadingOverlay.css';

/**
 * LoadingOverlay - A reusable full-screen transparent loading overlay.
 * Displays a centered spinner with a semi-transparent backdrop.
 * Prevents user interaction while loading via pointer-events.
 *
 * @param {boolean} isLoading - Controls visibility of the overlay.
 */
const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="loading-overlay" role="status" aria-label="Loading">
      <div className="loading-overlay__spinner-container">
        <div className="loading-overlay__spinner" />
        <span className="loading-overlay__text">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
